import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/es'

import enMessages from './messages/en.json'
import esMessages from './messages/es.json'
import {WithChildren} from '../helpers'

const allMessages = {
  en: enMessages,
  es: esMessages,
}

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider
      locale={locale}
      defaultLocale='en'
      messages={messages}
      onError={(err) => {
        // Silence missing-translation noise while the migration is in progress.
        if (err.code === 'MISSING_TRANSLATION') return
        console.error(err)
      }}
    >
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
